import { createContext, useContext, useState } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { AppContextData, AppData, AppProviderProps } from './types';
import { initialState } from './constants';
import { mutationKeys } from '@utils/consts';

const AppContext = createContext<AppContextData | Record<string, never>>({});

export const AppProvider = ({ children }: AppProviderProps) => {
  const [data, setData] = useState<AppData>(initialState);

  const fetching = useIsFetching();
  const mutating = useIsMutating({
    predicate: (mutation) => mutation.options.mutationKey !== mutationKeys.fileUpload,
  });

  return (
    <AppContext.Provider
      value={{
        ...data,
        setData,
        apiActivity: Boolean(fetching) || Boolean(mutating),
        mutationActivity: Boolean(mutating),
      }}>
      {children}
    </AppContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useAppContext = () => useContext(AppContext);
